/**
 * If property is not an array, it will return an array with one property
 * @param {Array|*} prop
 * @returns {Array}
 */
export const normalize = (prop) => {
  if (!prop) return [];
  return Array.isArray(prop) ? prop : [prop];
};

export const flatten = (arr) => arr.reduce(
  (acc, val) => acc.concat(
    Array.isArray(val) ? flatten(val) : val
  ),
  []
);



// WEBPACK FOOTER //
// ./frontend/react/sim/parser-mnx-geometry/utils/array.js